import config from './../modules/Config/Config';

let updateFormTracking = function() {};

// If there is a RedPoint configuration to load then include the library
if (config.redpoint && config.redpoint.length > 0) {

  //Sets the cookies for RPI tracking

  //Lifespan in days of the cookie
  var cookiesLifeSpan = 7;

  //pageGoalDetails
  var RPIGoals = null;
  var RPIPendingEvents = null;
  var RPIpageGoalName = '';
  var RPIpageGoalDetail = '';
  var RPIpageGoalContent = '';

  // Dynamic content
  var RPIDynamicContentLocations = null;

  function setFormTracking() {
    //Form parameter sets
    var cId = getCookie("cid");
    if (cId != undefined) {
      var hiddenElems = document.getElementsByName('rpiCID');
      for (var i = 0; i < hiddenElems.length; i++) {
        hiddenElems[i].value = cId;
      }
    }

    var exId = getCookie("exid");
    if (exId != undefined) {
      var hiddenElems = document.getElementsByName('rpiExID');
      for (var i = 0; i < hiddenElems.length; i++) {
        hiddenElems[i].value = exId;
      }
    }
  }

  function setRPITrackingParams(cookiesLifeSpan) {
    var urlParams = getRPIParamUrlVars();

    var cId = urlParams["cid"];
    if (cId != undefined) {
      setCookie("cid", cId, cookiesLifeSpan);
    }

    var exId = urlParams["exid"];
    if (exId != undefined) {
      setCookie("exid", exId, cookiesLifeSpan);
    }
  }

  //Get the required parameters from the URL
  function getRPIParamUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value;
    });
    return vars;
  }

  //Set cookie value function
  function setCookie(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString()) + "; path=/";
    document.cookie = c_name + "=" + c_value;
  }

  //Get cookie value function
  function getCookie(c_name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
      x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
      y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
      x = x.replace(/^\s+|\s+$/g, "");
      if (x == c_name) {
        return unescape(y);
      }
    }
  }

  function setRPIWebOfferParams(defaultContentID, contentKeys, cookiesLifeSpan) {
    var urlParams = getRPIParamUrlVars();

    //set the content id cookie
    var contentID = urlParams["ctid"];
    if (contentID == undefined) {
      setCookie("ctid", defaultContentID, cookiesLifeSpan);
      contentID = defaultContentID;
    }
    else {
      setCookie("ctid", contentID, cookiesLifeSpan);
    }

    //set the content key cookies
    for (var i = 0; i < contentKeys.length; i++) {
      var keyParam = "k" + contentKeys[i];
      var keyValue = urlParams[keyParam];
      var cookieName = "ct" + contentID + keyParam;
      if (keyValue == undefined) {
        if (getCookie(cookieName) == undefined) {
          setCookie(cookieName, "0", cookiesLifeSpan);
        }
      }
      else {
        setCookie(cookieName, keyValue, cookiesLifeSpan);
      }
    }
  }

  //Load html for div
  function loadRPIDiv(divName, key, address, pageInstanceID, contentID, processorAddress, clientID) {
    var webDiv = document.getElementById(divName);
    if (webDiv != undefined) {
      var url = getWebChannelLink(key, address, pageInstanceID, contentID, processorAddress, clientID);
      var ai = new AJAXInteraction(url, function (div, responseText) { document.getElementById(div).innerHTML = responseText; }, divName);
      ai.doGet();
    }
  }

  //build the URL
  function getWebChannelLink(key, address, pageInstanceID, contentPublishID, processorAddress, clientID) {
    var contentID = getCookie("ctid");
    var keyValue = getCookie("ct" + contentID + "k" + key);

    if (contentPublishID != undefined && contentPublishID != null && contentPublishID != '' &&
      processorAddress != undefined && processorAddress != null && processorAddress != '') {
      setPendingMetric(processorAddress, 'RealtimeDecision', null, keyValue, pageInstanceID, true, clientID, contentPublishID)
    }

    return address + contentID + "/" + key + "/" + keyValue + ".htm";
  }

  function GetURLParametersForProfile() {
    var url = window.location.href;

    var params = [];

    if (url.indexOf('?') > 0) {
      var pairs = url.substring(url.indexOf('?') + 1).split('&');
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        var key = decodeURIComponent(pair[0]);
        var val = decodeURIComponent(pair[1]);
        if (key != "cid" && key != "exid" && key != "rpimg") {
          params.push({ Name: key, Value: val });
        }
      }
    }
    if (params.length > 0)
      return params;
    else
      return null;
  }

  function parseVisitorID(data, storeVisitorID, clientID) {
    if (data != undefined) {
      var result = JSON.parse(data);

      if (storeVisitorID)
        setCookie(clientID, result.VisitorID, 365);

      return result.VisitorID;
    }
    else {
      return null;
    }
  }

  function submitVisitorDetails(rPIServer, clientID, pageTitle, rpipubid, inclGeolocation) {
    var urlParams = GetURLParametersForProfile();

    //if not available, get the page title
    if (pageTitle == undefined || pageTitle == null || pageTitle == '')
      pageTitle = document.title;

    registerForClickEvents(rPIServer, rpipubid, clientID);

    submitVisitorAjaxRequest(rPIServer, clientID, rpipubid, inclGeolocation, urlParams, function (data) {
      if (clientID == undefined || clientID == null)
        clientID == "RPIVisitorID";

      var visitorID = parseVisitorID(data, true, clientID);

      sendMetric(rPIServer, 'PageVisit', null, pageTitle, rpipubid, true, clientID, null, visitorID);
      flushPendingEvents(visitorID);
    });
  }

  function submitVisitorParameter(rPIServer, params, clientID, rpipubid, inclGeolocation, registerVisit, pageTitle) {
    if (registerVisit) {
      registerForClickEvents(rPIServer, rpipubid, clientID);
    }

    submitVisitorAjaxRequest(rPIServer, clientID, rpipubid, inclGeolocation, params, function (data) {
      if (clientID == undefined || clientID == null)
        clientID == "RPIVisitorID";
      var visitorID = parseVisitorID(data, true, clientID);

      if (registerVisit) {
        sendMetric(rPIServer, 'PageVisit', null, pageTitle, rpipubid, true, clientID, null, visitorID);
      }
      flushPendingEvents(visitorID);
    });
  }

  function submitVisitorParameterWithCallback(rPIServer, params, clientID, rpipubid, callback, inclGeolocation) {
    submitVisitorAjaxRequest(rPIServer, clientID, rpipubid, inclGeolocation, params, function (data) {
      if (clientID == undefined || clientID == null)
        clientID == "RPIVisitorID";
      parseVisitorID(data, true, clientID);
      if (callback != undefined)
        callback();
    });
  }


  function cacheDBDataSynch(rPIServer, lookupID, val, clientID, rpipubid) {
    var visitorID = submitVisitorSynchRequest(rPIServer, clientID, rpipubid);
    requestCacheDBData(rPIServer, lookupID, val, clientID, visitorID, false);
  }

  function cacheDBDataAsynch(rPIServer, lookupID, val, clientID, rpipubid, inclGeolocation) {
    submitVisitorAjaxRequest(rPIServer, clientID, rpipubid, inclGeolocation, null, function (data) {
      var visitorID = parseVisitorID(data, false, clientID);
      requestCacheDBData(rPIServer, lookupID, val, clientID, visitorID, false);
    });
  }

  function cacheDBDataSynchOnName(rPIServer, lookupName, val, clientID, rpipubid) {
    var visitorID = submitVisitorSynchRequest(rPIServer, clientID, rpipubid);
    requestCacheDBData(rPIServer, lookupName, val, clientID, visitorID, true);
  }

  function cacheDBDataAsynchOnName(rPIServer, lookupName, val, clientID, rpipubid, inclGeolocation) {
    submitVisitorAjaxRequest(rPIServer, clientID, rpipubid, inclGeolocation, null, function (data) {
      var visitorID = parseVisitorID(data, false, clientID);
      requestCacheDBData(rPIServer, lookupName, val, clientID, visitorID, true);
    });
  }

  function cacheDBData(rPIServer, lookupID, val, clientID, visitorID) {
    requestCacheDBData(rPIServer, lookupID, val, clientID, visitorID, false);
  }

  function cacheDBDataOnName(rPIServer, lookupName, val, clientID, visitorID) {
    requestCacheDBData(rPIServer, lookupName, val, clientID, visitorID, true);
  }

  function requestCacheDBData(rPIServer, lookupID, val, clientID, visitorID, lookupOnName) {
    if (visitorID != undefined) {

      if (clientID == undefined || clientID == null)
        clientID == "RPIVisitorID";

      setCookie(clientID, visitorID, 365);

      rPIServer = getAPIServer(rPIServer);
      var url = rPIServer + "/api/Cache/CachedAttributes";

      var requestDetails = {};
      requestDetails["VisitorID"] = visitorID;
      if (lookupOnName) {
        requestDetails["CachedAttributeName"] = lookupID;
      }
      else {
        requestDetails["CachedAttributeName"] = "";
        requestDetails["CachedAttributeListID"] = lookupID;
      }

      requestDetails["LookupValue"] = val;

      postRequest(url, JSON.stringify(requestDetails));
    }
  }

  //Load html for div
  function loadDynamicContent(rPIServer, divNames, contentIDs, defaultAddress, defaultKeys, clientID, pageTitle, pubID, inclGeolocation, persistSelection, masterMessageDivs) {
    if (clientID == undefined || clientID == null)
      clientID == "RPIVisitorID";

    var urlParams = GetURLParametersForProfile();

    if (pageTitle == undefined || pageTitle == null || pageTitle == '')
      pageTitle = document.title;

    registerForClickEvents(rPIServer, pubID, clientID);

    submitVisitorAjaxRequest(rPIServer, clientID, pubID, inclGeolocation, urlParams, function (data) {
      var visitorID = parseVisitorID(data, true, clientID);

      for (var i = 0; i < divNames.length; i++) {
        var isMasterMessage = (masterMessageDivs != undefined && masterMessageDivs != null && masterMessageDivs.indexOf(divNames[i]) >= 0);
        loadDynamicContentDiv(rPIServer, divNames[i], contentIDs[i], defaultAddress, visitorID, defaultKeys[i], pubID, persistSelection, isMasterMessage);
      }
      sendMetric(rPIServer, 'PageVisit', null, pageTitle, pubID, true, clientID, null, visitorID);
      flushPendingEvents(visitorID);
    }, function () {
      for (var i = 0; i < divNames.length; i++) {
        setDynamicContentDiv(divNames[i], contentIDs[i], defaultKeys[i], defaultAddress);
      }
      sendMetric(rPIServer, 'PageVisit', null, pageTitle, pubID, true, clientID);
    });
  }

  //Load html for div
  function loadDynamicContentDiv(rPIServer, divName, contentID, defaultAddress, visitorID, defaultKey, pubID, persistSelection, isMasterMessage) {

    if (visitorID != undefined) {
      var isNested = false;

      if (pubID == undefined || pubID == null || pubID == '') {
        pubID = '0';
      }

      var contentCookieName = contentID + '_' + pubID;
      if (persistSelection) {
        var resultCookie = getCookie(contentCookieName);
        if (resultCookie != undefined) {
          setDynamicContentDiv(divName, contentID, resultCookie, defaultAddress);
          return;
        }
      }

      var masterMessage = "&isMasterMessage=false";
      if (isMasterMessage == true) {
        masterMessage = "&isMasterMessage=true";
      }

      rPIServer = getAPIServer(rPIServer);
      var url = rPIServer + "/api/Decisions/" + contentID + "/" + visitorID + "?publishID=" + pubID + masterMessage + "&minuteOffSetUTC=" + encodeURIComponent(new Date().getTimezoneOffset());
      ajaxRequest(url, function (data) {
        var key = defaultKey;
        try {
          var result = JSON.parse(data);
          if (result.Result != undefined)
            key = result.Result;

          if (result.ContentID != undefined && result.ContentID != "") {
            isNested = (contentID != result.ContentID);
            contentID = result.ContentID;
          }

        } catch (e) {

        }

        if (key == "0" || key == "") {
          key = defaultKey;
        }

        if (key != "0") {
          if (persistSelection && !isNested) {
            setCookie(contentCookieName, key, 1);
          }
          setDynamicContentDiv(divName, contentID, key, defaultAddress);
        }
      }, function () {
        setDynamicContentDiv(divName, contentID, defaultKey, defaultAddress);
      });
    }
    else {
      setDynamicContentDiv(divName, contentID, defaultKey, defaultAddress);
    }
  }

  //Load html for div
  function getDecisionResult_Asynch(rPIServer, contentID, getIndex, clientID, onSuccess, onError, rpipubid, inclGeolocation) {
    submitVisitorAjaxRequest(rPIServer, clientID, rpipubid, inclGeolocation, null, function (data) {
        try {
          if (clientID == undefined || clientID == null)
            clientID == "RPIVisitorID";
          var visitorID = parseVisitorID(data, true, clientID);

          var result = getDecisionResult_Synch(rPIServer, contentID, getIndex, clientID, rpipubid);
          onSuccess(result);
        } catch (e) {
          if (onError != undefined && onError != null)
            onError(e);
        }
      }, onError
    );
  }

  function getDecisionResult_Synch(rPIServer, contentID, getIndex, clientID, rpipubid) {
    var visitorID = submitVisitorSynchRequest(rPIServer, clientID, rpipubid);

    if (visitorID != undefined) {
      setCookie(clientID, visitorID, 365);
      if (rpipubid == undefined || rpipubid == "")
        rpipubid = "0";

      if (getIndex = undefined || getIndex == null)
        getIndex = true;

      rPIServer = getAPIServer(rPIServer);
      var url = rPIServer + "/RPIVisitors/RequestResult.aspx?rpivisitorid=" + visitorID + "&decisionid=" + contentID + "&rpipubid=" + rpipubid + "&rpildt=" + encodeURIComponent(new Date().getTimezoneOffset());

      if (!getIndex)
        url = url + '&rpireqcontent=true';

      var xmlHttp = getXmlHttpObject();
      xmlHttp.open("GET", url, false);
      xmlHttp.send(null);
      return xmlHttp.responseText;
    }
    else {
      return '';
    }
  }

  function setDynamicContentDiv(divName, contentID, key, defaultAddress) {
    var contentAddress = getDynamicContentLocation(contentID, defaultAddress);

    var webDiv = document.getElementById(divName);
    if (webDiv != undefined) {
      var url = contentAddress + contentID + "/" + key + "/0.htm";
      var ai = new AJAXInteraction(url, function (div, responseText) { document.getElementById(div).innerHTML = responseText; }, divName);
      ai.doGet();
    }
  }

  function GetLatLonParameters(url, regDetails, onLocationSuccess) {
    if (navigator.geolocation) {

      var latLng;

      navigator.geolocation.getCurrentPosition(
        function (position) {
          latLng = true;
          if (position.coords != undefined && position.coords != null) {
            regDetails["Geolocation"] = { "Longitude": position.coords.longitude, "Latitude": position.coords.latitude };
          }
          onLocationSuccess(url, JSON.stringify(regDetails));
        },
        function (error) {
          latLng = true;
          onLocationSuccess(url, JSON.stringify(regDetails));
        },
        { maximumAge: 300000, timeout: 10000 });

      setTimeout(
        function () {
          if (!latLng) {
            onLocationSuccess(url, JSON.stringify(regDetails));
          }
        }, 6000
      );
    }
    else {
      onLocationSuccess(url, JSON.stringify(regDetails));
    }
  }

  function getVisitorRegistrationDetails(clientID, rpipubid, params) {

    if (clientID == undefined || clientID == null)
      clientID == "RPIVisitorID";

    if (rpipubid == undefined || rpipubid == null)
      rpipubid = "0";

    var visitorID = getCookie(clientID);

    var urlParams = getRPIParamUrlVars();
    var exID = urlParams["exid"];
    var cID = urlParams["cid"];
    var msgIDs = urlParams["rpimg"];

    var visitDetails = {};
    visitDetails["PagePublishedID"] = rpipubid;
    if (visitorID != undefined) {
      visitDetails["IsNewVisitor"] = false;
      visitDetails["VisitorID"] = visitorID;
    }
    else {
      visitDetails["IsNewVisitor"] = true;
    }

    if (params != null) {
      visitDetails["VisitorAttributes"] = params;
    }

    var trackingObjects = {};
    if (exID != undefined) {
      trackingObjects["ChannelExecutionID"] = exID;
      if (cID != undefined) {
        trackingObjects["RPContactID"] = cID;
      }
    }

    if (msgIDs != undefined) {
      var msgComp = msg.split("_");
      if (msgComp.length > 1) {
        trackingObjects["MessageListID"] = msgComp[0];
        trackingObjects["MessageID"] = msgComp[1];
      }
    }

    visitDetails["InteractionTracking"] = trackingObjects;

    if (clientID != "RPIVisitorID") {
      visitDetails["ClientID"] = clientID;
    }

    var docref = document.referrer;

    if (docref != undefined && docref != null && docref != '') {
      visitDetails["PageReferrer"] = docref;
    }

    return visitDetails;
  }

  function getVisitorURL(rPIServer) {
    rPIServer = getAPIServer(rPIServer);
    return rPIServer + "/api/Cache/Visit";
  }


  function submitVisitorSynchRequest(rPIServer, clientID, rpipubid) {
    var url = getVisitorURL(rPIServer);
    var regDetails = getVisitorRegistrationDetails(clientID, rpipubid, null)
    var resp = postRequest(url, JSON.stringify(regDetails));
    return parseVisitorID(resp, false, clientID);
  }

  function submitVisitorParameterSynchRequest(rPIServer, paramName, paramValue, clientID, rpipubid) {

    return submitVisitorSynchRequest(rPIServer, clientID, rpipubid, [{ Name: paramName, Value: paramValue }]);
  }

  function submitVisitorAjaxRequest(rPIServer, clientID, rpipubid, inclGeolocation, params, onSuccess, onError) {
    var url = getVisitorURL(rPIServer);
    var regDetails = getVisitorRegistrationDetails(clientID, rpipubid, params)
    if (inclGeolocation == true) {
      GetLatLonParameters(url, regDetails, function (newURL, contents) {
        ajaxPostRequest(newURL, contents, onSuccess, onError);
      })
    }
    else {
      return ajaxPostRequest(url, JSON.stringify(regDetails), onSuccess, onError);
    }
  }

  function CacheFBParam(FB, serverAddress, clientID, pubID, edges, reload) {
    var batchArray = new Array();
    batchArray[0] = { method: 'GET', relative_url: 'me' };
    for (var i = 0; i < edges.length; i++) {
      batchArray[i + 1] = { method: 'GET', relative_url: 'me/' + edges[i] };
    }

    FB.api('/', 'POST', {
      batch: batchArray
    }, function (responses) {

      var params = [];
      if (responses.length >= 1 && responses[0].body != undefined && responses[0].body != null) {
        var response = JSON.parse(responses[0].body);
        params.push({ Name: "Facebook_ID", Value: response.id });
        params.push({ Name: "Facebook_Name", Value: response.name });
        params.push({ Name: "Facebook_FirstName", Value: response.first_name });
        params.push({ Name: "Facebook_LastName", Value: response.last_name });
        params.push({ Name: "Facebook_Is_Logged_In", Value: "true" });

        if (response.username != null && response.username != undefined) {
          params.push({ Name: "Facebook_username", Value: response.username });
        }
        if (response.gender != null && response.gender != undefined) {
          params.push({ Name: "Facebook_Gender", Value: response.gender });
        }
        if (response.locale != null && response.locale != undefined) {
          params.push({ Name: "Facebook_Locale", Value: response.locale });
        }
        if (response.email != null && response.email != undefined) {
          params.push({ Name: "Facebook_Email", Value: response.email });
        }
        if (response.birthday != null && response.birthday != undefined) {
          params.push({ Name: "Facebook_Birthday", Value: response.birthday });
        }
        if (response.location != null && response.location != undefined) {
          params.push({ Name: "Facebook_Location", Value: response.location.name });
        }
        if (response.hometown != null && response.hometown != undefined) {
          params.push({ Name: "Facebook_Hometown", Value: response.hometown.name });
        }
      }
      for (var i = 0; i < edges.length; i++) {
        if (responses.length >= i + 2 && responses[0].body != undefined && responses[i + 1].body != null) {
          var response = JSON.parse(responses[i + 1].body);
          if (response.data != undefined && response.data != null) {
            var nameVals = '';
            for (var j = 0; j < response.data.length; j++) {
              if (response.data[j].name != undefined && response.data[j].name != null) {
                if (nameVals != '')
                  nameVals = nameVals + '_';
                nameVals = nameVals + response.data[j].name;
              }
            }
            if (nameVals != '') {
              if (edges[i] == 'likes') {
                params.push({ Name: "Facebook_Likes", Value: nameVals });
              }
              else if (edges[i] == 'events') {
                params.push({ Name: "Facebook_Events", Value: nameVals });
              }
              else {
                params.push({ Name: "Facebook_" + edges[i], Value: nameVals });
              }
            }

          }
        }
      }

      if (params != '') {
        if (reload == true)
          submitVisitorParameterWithCallback(serverAddress, params, clientID, pubID, function () { location.reload() });
        else
          submitVisitorParameter(serverAddress, params, clientID, pubID);
      }
      else {
        submitVisitorParameter(serverAddress, [{ Name: "Facebook_Is_Logged_In", Value: "false" }], clientID, pubID);
      }

    });
  }

  function setDynamicContentLocation(contentID, contentAddress) {
    var lkup = { id: contentID, address: contentAddress };
    if (RPIDynamicContentLocations == null)
      RPIDynamicContentLocations = [lkup];
    else
      RPIDynamicContentLocations[RPIDynamicContentLocations.length] = lkup;
  }

  function getDynamicContentLocation(contentID, defaultAddress) {
    if (RPIDynamicContentLocations != null) {
      for (var i = 0, len = RPIDynamicContentLocations.length; i < len; i++) {
        var location = RPIDynamicContentLocations[i];
        if (location["id"] == contentID)
          return location["address"];
      }
    }
    return defaultAddress;
  }

  function setPendingMetric(address, state, stateValue, extraParam, publishedID, isAsynch, clientID, contentID) {
    //check to see if visitor ID is available
    if (clientID == undefined || clientID == null)
      clientID == "RPIVisitorID";

    var visitorID = getCookie(clientID);
    if (visitorID == undefined || visitorID == null || visitorID == '') {
      var rpiEvent = { address: address, state: state, stateValue: stateValue, extraParam: extraParam, publishedID: publishedID, clientID: clientID, contentID: contentID };
      if (RPIPendingEvents == null)
        RPIPendingEvents = [rpiEvent];
      else
        RPIPendingEvents[RPIPendingEvents.length] = rpiEvent;
    }
    else {
      sendMetric(address, state, stateValue, extraParam, publishedID, isAsynch, clientID, contentID, visitorID);
    }
  }

  function flushPendingEvents(visitorID) {
    //Set visitorID
    if (visitorID != undefined || visitorID != null) {
      var hiddenElems = document.getElementsByName('rpiVisitorID');
      for (var i = 0; i < hiddenElems.length; i++) {
        hiddenElems[i].value = visitorID;
      }
    }

    if (RPIPendingEvents != null) {
      for (var i = 0, len = RPIPendingEvents.length; i < len; i++) {
        var state = RPIPendingEvents[i];
        sendMetric(state["address"], state["state"], state["stateValue"], state["extraParam"], state["publishedID"], true, state["clientID"], state["contentID"], visitorID)
      }
      RPIPendingEvents = null;
    }
  }

  //post metric value
  function sendMetric(address, state, stateValue, extraParam, publishedID, isAsynch, clientID, contentID, visitorID) {

    var url = getAPIServer(address) + '/api/Events';

    var cid = getCookie("cid");
    var exid = getCookie("exid");

    var eventDetails = {};
    eventDetails["EventName"] = state;

    if (exid != undefined) {
      eventDetails["ChannelExecutionID"] = exid;
    }

    if (cid != undefined) {
      eventDetails["RPContactID"] = cid;
    }

    if (stateValue != null) {
      eventDetails["MetricValue"] = stateValue;
    }

    if (extraParam != null) {
      eventDetails["EventDetail"] = extraParam;
    }

    if (publishedID == undefined || publishedID == null || publishedID == '') {
      publishedID = '0';
    }

    eventDetails["PagePublishedID"] = publishedID;

    if (clientID == undefined || clientID == null)
      clientID == "RPIVisitorID";

    if (visitorID == undefined || visitorID == null)
      visitorID = getCookie(clientID);

    if (visitorID != undefined && visitorID != '' && visitorID != null)
      eventDetails["VisitorID"] = visitorID;

    if (clientID != "RPIVisitorID") {
      eventDetails["ClientID"] = clientID;
    }

    if (contentID != undefined && contentID != null) {
      eventDetails["ContentID"] = contentID;
    }

    if (state == 'PageVisit') {

      if (exid != undefined) {
        eventDetails["PageReferral"] = "exid" + exid;
      }
      else {
        var docref = document.referrer;

        if (docref != undefined && docref != null && docref != '') {
          eventDetails["PageReferral"] = docref;
        }
        else {
          eventDetails["PageReferral"] = "Direct";
        }
      }
    }

    if (RPIGoals != null) {
      var goalDetail = {};
      for (var i = 0, len = RPIGoals.length; i < len; i++) {
        var goal = RPIGoals[i];
        if (goal["state"] != undefined && goal["state"] != null
          && goal["content"] != undefined && goal["content"] != null && goal["content"] != ''
          && goal["state"].toLowerCase() == state.toLowerCase()) {

          if (goal["detail"] == undefined || goal["detail"] == null || goal["detail"] == '') {
            goalDetail["GoalContentID"] = goal["content"];
            if (goal["name"] != undefined && goal["name"] != null && goal["name"] != '') {
              goalDetail["GoalName"] = goal["name"];
            }
            eventDetails["GoalDetails"] = goalDetail;
          }
          else if (extraParam != undefined && extraParam != null && extraParam.toLowerCase().indexOf(goal["detail"].toLowerCase()) >= 0) {
            goalDetail["GoalContentID"] = goal["content"];
            if (goal["name"] != undefined && goal["name"] != null && goal["name"] != '') {
              goalDetail["GoalName"] = goal["name"];
            }
            eventDetails["GoalDetails"] = goalDetail;
          }
        }
      }
    }

    var mygetrequest = getXmlHttpObject()
    mygetrequest.onreadystatechange = function () {
      if (mygetrequest.readyState == 4) {
        if (mygetrequest.status != 200 && window.location.href.indexOf("http") != -1) {
          //An error has occured making the request
        }
      }
    }

    if (isAsynch == undefined)
      isAsynch = true;

    if (isAsynch) {
      ajaxPostRequest(url, JSON.stringify(eventDetails));
    }
    else {
      postRequest(url, JSON.stringify(eventDetails));
    }
  }

//Registers a page visit
  function registerPageVisit(address, pageName, clientID, publishedID) {
    if (pageName == undefined || pageName == null || pageName == '')
      pageName = document.title;

    sendMetric(address, 'PageVisit', null, pageName, publishedID, true, clientID);

    registerForClickEvents(address, publishedID, clientID);
  }

  function registerForClickEvents(address, publishedID, clientID) {
    var elements = document.getElementsByTagName('a');
    for (var i = 0, len = elements.length; i < len; i++) {
      elements[i].onclick = function () {
        sendMetric(address, 'PageLinkClick', null, this.href, publishedID, false, clientID);
      }
    }
  }

  function setPageGoalDetails(goalName, stateName, goalDetail, contentIDs) {
    var goal = { name: goalName, state: stateName, detail: goalDetail, content: contentIDs };
    if (RPIGoals == null)
      RPIGoals = [goal];
    else
      RPIGoals[RPIGoals.length] = [goal];
  }

  function getAPIServer(rPIServer) {
    if (rPIServer.indexOf("http") == 0) {
      return rPIServer;
    }
    else {
      return (("https:" == document.location.protocol) ? "https://" + rPIServer : "http://" + rPIServer);
    }
  }

  function getXmlHttpObject() {
    var xmlHttp;
    try {
      // Firefox, Opera 8.0+, Safari
      xmlHttp = new XMLHttpRequest();
    } catch (e) {
      // Internet Explorer
      try {
        xmlHttp = new ActiveXObject("Msxml2.XMLHTTP");
      } catch (e) {
        xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
    }
    if (!xmlHttp) {
      return false;
    }
    return xmlHttp;
  }

//sets the div with the dynamic content
  function AJAXInteraction(url, callback, divName) {

    var req = getXmlHttpObject();
    req.onreadystatechange = processRequest;

    function processRequest() {
      if (req.readyState == 4) {
        if (req.status == 200) {
          if (callback) callback(divName, req.responseText);
        }
      }
    }

    //Load html scripts
    this.doGet = function () {
      req.open("GET", url, true);
      req.send(null);
    }
  }

  function ajaxRequest(url, onSuccess, onError) {
    var xmlHttp = getXmlHttpObject();
    xmlHttp.onreadystatechange = function () {
      if (this.readyState === 4) {

        // onSuccess
        if (this.status === 200 && typeof onSuccess == 'function') {
          onSuccess(this.responseText);
        }
        // onError
        else if (typeof onError == 'function') {
          onError();
        }

      }
    };
    xmlHttp.open("GET", url, true);
    xmlHttp.setRequestHeader("Accept", "application/json");
    xmlHttp.send(null);
    return xmlHttp;
  }

  function postRequest(url, contents) {
    var xmlHttp = getXmlHttpObject();
    xmlHttp.open("POST", url, false);
    xmlHttp.setRequestHeader("Accept", "application/json");
    xmlHttp.setRequestHeader("Content-type", "text/plain");
    xmlHttp.send(contents);
    return xmlHttp.responseText;
  }

  function ajaxPostRequest(url, contents, onSuccess, onError) {
    //$(document).ready(function () {
    //    $.ajax({
    //        url: url,
    //        type: "POST",
    //        data: contents,
    //        contentType: 'text/plain',
    //        success: function (data) { onSuccess(data); },
    //        error: function () { onError(); }
    //    })
    //});
    var xmlHttp = getXmlHttpObject();
    xmlHttp.onreadystatechange = function () {
      if (this.readyState === 4) {

        // onSuccess
        if (this.status === 200 && typeof onSuccess == 'function') {
          onSuccess(this.responseText);
        }
        // onError
        else if (typeof onError == 'function') {
          onError();
        }

      }
    };
    xmlHttp.open("POST", url, true);
    xmlHttp.setRequestHeader("Accept", "application/json");
    xmlHttp.setRequestHeader("Content-type", "text/plain");

    console.log(contents);
    xmlHttp.send(contents);
    return xmlHttp;
  }

  //Sets the cookies with the RPI URL parameters
  setRPITrackingParams(cookiesLifeSpan);

  // Generate a global _paq variable
  window._paq = window._paq || [];

  (function () {
    var u = (("https:" == document.location.protocol) ? "https://rpwt.rphelios.net/wgbhwt/"
      : "http://rpwt.rphelios.net/wgbhwt/");
    var urlParams = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      urlParams[key] = value;
    });
    var cId = urlParams["cid"];
    var exId = urlParams["exid"];
    var rpiClientID = urlParams["clid"];
    _paq.push(['setSiteId', 6]);
    _paq.push(['setTrackerUrl', u + 'piwik.php']);
    _paq.push(['setDocumentTitle', '""']);
    if (cId != undefined) {
      _paq.push(['setCustomVariable', 2, "RPContactID", cId, scope = "visit"]);
    }
    if (exId != undefined) {
      _paq.push(['setCustomVariable', 1, "ChannelExecutionID", exId, scope = "visit"]);
    }
    if (rpiClientID != undefined) {
      _paq.push(['setCustomVariable', 3, "RPClientID", rpiClientID, scope = "visit"]);
    }
    _paq.push(["setCookieDomain", "*.tpt.org"]);
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript';
    g.defer = true;
    g.async = true;
    g.src = u + 'piwik.js';
    s.parentNode.insertBefore(g, s);
  })();

  // Define a custom function on the RedPoint tracking queue for updating
  // RedPoint forms on demand
  updateFormTracking = function updateFormTracking() {
    var visitor_id;
    _paq.push([function () {

      // Begin RedPoint form set up logic
      visitor_id = this.getVisitorId();

      if (visitor_id != undefined) {
        var hiddenElems = document.getElementsByName('rpiTrkPiwikVisitorID');
        for (var i = 0; i < hiddenElems.length; i++) {
          hiddenElems[i].value = visitor_id;
        }
      }

      setFormTracking();
      // End RedPoint form set up logic

      // This code is a part of the RedPoint landing page, but executing
      // it generates a failed ajax request to the RedPoint server. Currently
      // not running this piece until RedPoint can give an answer on why
      // this behaves this way.
      // Request causes 500 Internal Server error

      //var rPIWebServer = 'ecommunications.tpt.org';
      //submitVisitorParameter(rPIWebServer, 'PiwikVisitorID', visitor_id, '466f7180-a177-41e2-9351-ea5071827c46', '285');
    }]);
  };

  // Execute the form update once on load to mimic the default RedPoint behavior
  updateFormTracking();
}

export default {
  updateFormTracking: updateFormTracking
}